import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("giva_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo correu mal. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const APP_STORE_URL = "https://apps.apple.com/gb/app/giva-solution/id6760744865";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.dcodax.giva";
export const DRIVER_APP_URL = "https://apps.apple.com/gb/app/giva-driver/id6760752699";
export const PRIVACY_URL = "https://givasolutions.com/privacy-policy";
export const WEBSITE_URL = "https://givasolutions.com";
export const SUPPORT_EMAIL = "support@givasolutions.com";
export const SUPPORT_PHONE = "+351935544765";
export const LOGO_URL = "/assets/giva-logo.png";
